module.exports = __webpack_public_path__ + "static/media/7-1.da6dd221.mp3";